import React from "react";
import { motion } from "framer-motion";

const EXETimeline = () => {
  const timelineEvents = [
    {
      date: "Jun 18",
      title: "Registration Opens",
      description: "Individual and team registration begins"
    },
    {
      date: "Jul 28",
      title: "Registration Closes",
      description: "Final day for registration and team formation"
    },{
      date: "Aug 1",
      title: "Commencement",
      description: "Start of EXE and Theme Reveal"
    },
    {
      date: "Aug 3-9",
      title: "GDD Phase",
      description: "Creating a Game Design Document"
    },
    {
      date: "Aug 11-23",
      title: "Game Dev Phase",
      description: "14-day development period"
    },
    {
      date: "Aug 24",
      title: "Submission Deadline",
      description: "All projects must be submitted by midnight"
    },
    {
      date: "Aug 25-27",
      title: "Judging Period",
      description: "Expert panel reviews and evaluates submissions"
    },
    {
      date: "Aug 30",
      title: "Awards Ceremony",
      description: "Winners announced and prizes distributed"
    }
  ];

  return (
    <section className="exe-section">
      <div className="exe-container">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="exe-title text-exe-text-accent mb-6">
              Competition Timeline
            </h2>
            <div className="h-1 w-24 bg-exe-gradient-primary mx-auto mb-8"></div>
          </motion.div>

          <div className="space-y-8">
            {timelineEvents.map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="exe-glass-card p-6 flex items-center gap-6"
              >
                <div className="text-center min-w-[80px]">
                  <div className="exe-heading text-exe-text-accent">{event.date}</div>
                </div>
                <div className="flex-1">
                  <h3 className="exe-heading mb-2">{event.title}</h3>
                  <p className="exe-text">{event.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EXETimeline;
